var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-header-container"},[_c('div',{staticClass:"c-header-item"},[_vm._v(" "+_vm._s(_vm.resource["userHeader.Name"])+" ")]),_c('div',{staticClass:"c-header-item"},[_vm._v(" "+_vm._s(_vm.resource["userHeader.Surname"])+" ")]),_c('div',{staticClass:"c-header-item"},[_vm._v(" "+_vm._s(_vm.resource["userHeader.Email"])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }